import { ReviewCreationData } from '../../../types/review-creation-data';

export const createReview = async (reviewCreationData: ReviewCreationData): Promise<Response> => {
    return await fetch('/cr-review-submission/review/v1', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify(reviewCreationData),
    });
};
